import { render, staticRenderFns } from "./DocsMgmt.vue?vue&type=template&id=450a09ef&scoped=true&"
import script from "./DocsMgmt.vue?vue&type=script&lang=js&"
export * from "./DocsMgmt.vue?vue&type=script&lang=js&"
import style0 from "./DocsMgmt.vue?vue&type=style&index=0&id=450a09ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a09ef",
  null
  
)

export default component.exports